import OnboardingSteps from './OnboardingSteps';

export default OnboardingSteps;
